module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fg2gQK/tc-custom/9781459222854.jpg?1734557018287",
      "alt": "This image is the cover for the book Unstoppable"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Unstoppable\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("New York Times "), _c('i', [_vm._v("bestselling author Suzanne Brockman brings readers two beloved stories of men who will stop at nothing to get the women they love.")]), _c('br'), _c('br'), _c('i', [_vm._v("Love with the Proper Stranger")]), _c('br'), _c('br'), _vm._v("FBI agent John Miller was on the trail of a notorious female serial killer, and he couldn't blow his cover to anyone. Not even the beguiling Mariah Carver, who had unwittingly entangled herself in a web of deadly deceit. The daring lawman couldn't deny his feelings for Mariah, but he was poised to wed another woman: the ruthless Black Widow, who marriesthen murdersher victims."), _c('br'), _c('br'), _c('i', [_vm._v("Letters to Kelly")]), _c('br'), _c('br'), _vm._v("For years, a trumped-up chargeand a Central American prison cellkept Jax Winchester from claiming the girl he loved. Now he was a free man. Or was he? He was still a prisoner, in a jail of his own making. The way out this time? Keep that promise he'd made to Kelly O'Brien all those years agoand claim her for his own."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Suzanne Brockmann\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Suzanne Brockmann is an award-winning author of more than fifty books and is widely recognized as one of the leading voices in romantic suspense. Her work has earned her repeated appearances on the New York Times bestseller list, as well as numerous awards, including Romance Writers of America’s #1 Favorite Book of the Year and two RITA awards. Suzanne divides her time between Siesta Key and Boston. Visit her at www.SuzanneBrockmann.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0